import { inject, Injectable } from '@angular/core';
import { PiHistorikDatasource } from '@features/pengeinstitutter/pi-historik/pi-historik.datasource';

@Injectable({
  providedIn: 'root'
})
export class PengeinstitutHistorikService  {
  datasource = inject(PiHistorikDatasource);
}
